import { CartTable } from "../../ui";
import { useNavigate } from "react-router";
import { formatPriceWithCurrency } from "../../utils";
import { useCart } from "./useCart";

export const CartPage = () => {
    const navigate = useNavigate();
    const {
        cartWithProducts,
        totalCost,
        checkoutReadyData
    } = useCart();

    const [isCheckoutReady, checkoutUnreadyReasons] = checkoutReadyData;

    return (
        <>
            <section className="section">
                <div className="inside-wrapper">


                    <ol className="ordersteps">
                        <li className="ordersteps__step m-ok">Upload your photos</li>
                        <li className="ordersteps__step">Make a payment</li>
                        <li className="ordersteps__step">Download your video</li>
                    </ol>


                    <h1 className="section__title">
                        Your cart
                    </h1>


                    <CartTable cartItems={cartWithProducts}/>

                    <div className="carttotal">
                        <div className="carttotal__total" style={{
                            marginLeft: 'auto',
                            marginRight: 0,
                        }}>
                            <div className="carttotal__total-title">
                                Your Cart Total
                            </div>
                            <div className="carttotal__total-amount">
                                {totalCost ? formatPriceWithCurrency(totalCost) : '0.00'}
                            </div>
                            <div className="carttotal__btns">
                                <button
                                    onClick={() => {
                                        if (isCheckoutReady) {
                                            navigate('/checkout');
                                        }
                                    }}
                                    title={`${isCheckoutReady ? "" : checkoutUnreadyReasons.join("\n")}`}
                                    className="btn btn_cta btn_lg"
                                    disabled={!isCheckoutReady}>
                                    <svg role="img" className="btn__ico">
                                        <use href="./img/sprite.svg#lock"></use>
                                    </svg>
                                    SECURE CHECKOUT
                                </button>
                            </div>
                            <div className="carttotal__note">
                                Price displayed excludes any applicable taxes and a&nbsp;handling fee.
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
}

export default CartPage;